import ApplicationInput from "~/components/application/input";
import ApplicationRulesOfSilencio from "~/components/application/ruleOfSilencio";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";

const ApplicationAboutYouJob = () => {
  const { language } = useLanguage();
  const applyTexts =
    language === "En"
      ? englishTranslations.applyPage
      : frenchTranslations.applyPage;

  return (
    <>
      <div>
        <p>{applyTexts.applicationForm.job}</p>
        <ApplicationInput
          register="industry"
          placeholder={applyTexts.applicationForm.industry}
          label="industry"
          size={7}
          required
        />
        <br />
        <ApplicationInput
          register="jobTitle"
          placeholder={applyTexts.applicationForm.jobTitle}
          label="job title"
          size={7}
          required
        />
        <br />
        <ApplicationInput
          register="companyName"
          placeholder={applyTexts.applicationForm.companyName}
          label="company name"
          size={12}
          required
        />
        <br />
        <ApplicationInput
          register="professionalEmail"
          placeholder={applyTexts.applicationForm.professionalEmail}
          label="professional email"
          size={23}
        />
        <br />
        <ApplicationInput
          register="workTown"
          placeholder={applyTexts.applicationForm.town}
          label="town"
          size={4}
        />
        <br />
      </div>

      <p>
        *{applyTexts.applicationForm.dataStore}{" "}
        <ApplicationRulesOfSilencio
          text={`→ ${applyTexts.applicationForm.privacyPolicy}`}
        />
      </p>
    </>
  );
};

export default ApplicationAboutYouJob;
